module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-complimentary-exam"
  }, [_c('div', {
    staticClass: "modal-complimentary-exam__bg"
  }, [_c('div', {
    staticClass: "modal-complimentary-exam__container"
  }, [_c('div', {
    staticClass: "modal-complimentary-exam__close",
    on: {
      "click": function($event) {
        _vm.$emit("closeComplimentaryModal")
      }
    }
  }), _c('div', {
    staticClass: "modal-complimentary-exam__body"
  }, [_c('div', {
    staticClass: "modal-complimentary-exam__title"
  }, [_vm._v("Complimentary Exam")]), _vm._m(0), _c('ComplimentaryExamForm')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-complimentary-exam__content"
  }, [_vm._v("Interested in having Dr. Miller look at you or a loved one? Fill out this form and tell us your concerns. Someone will call you shortly to ask several follow up questions and schedule the appointment. Otherwise, give us a call at "), _c('a', {
    staticClass: "modal-complimentary-exam__phone-number",
    attrs: {
      "href": "tel:7406546006"
    }
  }, [_vm._v("(740) 654 - 6006 ")]), _vm._v("during normal business hours and we will answer any questions you have. If no one answers, leave us a message, and we will call you back the next working day. ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baeed1a4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal-complimentary-exam/modal-complimentary-exam.pug
// module id = 597
// module chunks = 1